// New file: components/Dashboard/AverageLossMetric.js
import React from "react";
import { TrendingDown } from "lucide-react";

const AverageLossMetric = ({ trades }) => {
  const calculateAverageLoss = (trades) => {
    const losingTrades = trades.filter(trade => trade.pnl < 0);
    if (losingTrades.length === 0) return 0;

    const avgLossPercent = losingTrades.reduce((sum, trade) => {
      const percentReturn = ((trade.exitPrice - trade.entryPrice) / trade.entryPrice) * 100;
      return sum + Math.abs(percentReturn);
    }, 0) / losingTrades.length;

    return avgLossPercent.toFixed(2);
  };

  return (
    <div className="metric-card">
      <div className="metric-header">
        <h3>Average Loss %</h3>
        <TrendingDown size={20} className="metric-icon" />
      </div>
      <div className="metric-content">
        <span className="metric-value loss">-{calculateAverageLoss(trades)}%</span>
        <span className="metric-subtitle">Average Return on Losses</span>
      </div>
    </div>
  );
};

export default AverageLossMetric;